import React from 'react';

function SmoothScrollLink({ href, children }) {
  const handleClick = (event) => {
    event.preventDefault();
    const targetId = href.substring(1);
    const target = document.getElementById(targetId);
    if (target) {
      // .post-auth-container is the scroll container for logged-in users, fallback to window
      const container = document.querySelector('.post-auth-container');
      if (container) {
        const elementTop = target.getBoundingClientRect().top - container.getBoundingClientRect().top + container.scrollTop;
        container.scrollTo({ top: elementTop - 90, behavior: 'smooth' });
      } else {
        const elementTop = target.getBoundingClientRect().top + window.pageYOffset;
        window.scrollTo({ top: elementTop - 90, behavior: 'smooth' });
      }
    }
  };

  return (
    <a href={href} onClick={handleClick} style={{textDecoration: "none"}}>
      {children}
    </a>
  );
}

export default SmoothScrollLink;